// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MinusSquareFilledSvg from "@ant-design/icons-svg/es/asn/MinusSquareFilled";
import AntdIcon from '../components/AntdIcon';

var MinusSquareFilled = function MinusSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MinusSquareFilledSvg
  }));
};

MinusSquareFilled.displayName = 'MinusSquareFilled';
export default React.forwardRef(MinusSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/MinusSquareFilled.js
// module id = 1495
// module chunks = 0